import { render, staticRenderFns } from "./ArticlesTag.vue?vue&type=template&id=0c456dc2"
import script from "./ArticlesTag.vue?vue&type=script&lang=js"
export * from "./ArticlesTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports